import {
	Button,
	DatePicker,
	Form,
	Input,
	Modal,
	Select
} from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
	loadSingleStaff,
	updateUser
} from "../../../redux/rtk/features/user/userSlice";
import BtnEditSvg from "../Button/btnEditSvg";


const ProfileEditPopup = ({ data }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [loader, setLoader] = useState(false);
	const user = useSelector((state) => state.users?.user);
	const { id } = useParams();
	const dispatch = useDispatch();
	const [form] = Form.useForm();

	useEffect(() => {

		if (user) {
			form.setFieldsValue({
				firstName: user.firstName || "",
				lastName: user.lastName || "",
				fatherName: user.fatherName || "",
				email: user.email || "",
				bloodGroup: user.bloodGroup || "",
				birthAnniversary: user.birthAnniversary ? dayjs(user.birthAnniversary) : null,
				birthdate: user.birthdate ? dayjs(user.birthdate) : null,
				maritalStatus: user.maritalStatus ? "Married" : "Single",
				marriageAnniversary: user.marriageAnniversary ? dayjs(user.marriageAnniversary) : null,
				gender: user.gender || "",
				pan: user.pan || "",
				aadhar: user.aadhar || "",
			});
		}
	}, [user, form]);

	const showModal = () => setIsModalOpen(true);
	const handleCancel = () => setIsModalOpen(false);
	const onFinish = async (values) => {
		try {
			setLoader(true);
	
			// Format the dates to only have the date part, not the time
			const updatedValues = {
				...values,
				birthdate: values.birthdate ? values.birthdate.format("YYYY-MM-DD") : null,
				birthAnniversary: values.birthAnniversary ? values.birthAnniversary.format("YYYY-MM-DD") : null,
				marriageAnniversary: values.marriageAnniversary ? values.marriageAnniversary.format("YYYY-MM-DD") : null,
				maritalStatus: values.maritalStatus === "Married" ? true : false
			};
	
			const resp = await dispatch(
				updateUser({
					id: id,
					values: updatedValues,
				})
			);
	
			if (resp.payload.message === "success") {
				dispatch(loadSingleStaff(id));
				toast.success("User information updated successfully");
				setIsModalOpen(false);
			} else {
				toast.error("Error updating user information");
			}
		} catch (error) {
			console.error(error.message);
			toast.error("Something went wrong");
		} finally {
			setLoader(false);
		}
	};
	

	// const onFinish = async (values) => {
	// 	try {
	// 		setLoader(true);
	// 		const updatedValues = {
	// 			...values,
	// 			maritalStatus: values.maritalStatus === "Married" ? true : false
	// 		};

	// 		const resp = await dispatch(
	// 			updateUser({
	// 				id: id,
	// 				values: updatedValues,
	// 			})
	// 		);

	// 		if (resp.payload.message === "success") {
	// 			dispatch(loadSingleStaff(id));
	// 			toast.success("User information updated successfully");
	// 			setIsModalOpen(false);
	// 		} else {
	// 			toast.error("Error updating user information");
	// 		}
	// 	} catch (error) {
	// 		console.error(error.message);
	// 		toast.error("Something went wrong");
	// 	} finally {
	// 		setLoader(false);
	// 	}
	// };


	return (
		<>
			<button onClick={showModal}>
				<BtnEditSvg size={30} />
			</button>
			<Modal
				width="50%"
				title="Update User Information"
				open={isModalOpen}
				onCancel={handleCancel}
				footer={null}>
				<Form
					form={form}
					layout="vertical"
					onFinish={onFinish}
					initialValues={form.getFieldsValue()}>
					<Form.Item
						label="First Name"
						name="firstName"
						rules={[{ required: true, message: "Please input First Name!" }]}>
						<Input placeholder="First Name" />
					</Form.Item>
					<Form.Item
						label="Last Name"
						name="lastName"
						rules={[{ required: true, message: "Please input Last Name!" }]}>
						<Input placeholder="Last Name" />
					</Form.Item>
					<Form.Item label="Father Name" name="fatherName">
						<Input placeholder="Father Name" />
					</Form.Item>
					<Form.Item
						label="Email"
						name="email"
						rules={[
							{ required: true, type: "email", message: "Please input a valid email!" },
						]}>
						<Input placeholder="Email" />
					</Form.Item>
					<Form.Item label="Blood Group" name="bloodGroup">
						<Select placeholder="Select Blood Group">
							{["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"].map((group) => (
								<Select.Option key={group} value={group}>
									{group}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="Birth Date" name="birthdate">
						<DatePicker format="YYYY-MM-DD" />
					</Form.Item>
					<Form.Item label="Birth Anniversary" name="birthAnniversary">
						<DatePicker format="YYYY-MM-DD" />
					</Form.Item>
					<Form.Item label="Marital Status" name="maritalStatus">
						<Select placeholder="Select Status">
							<Select.Option value="Single">Single</Select.Option>
							<Select.Option value="Married">Married</Select.Option>
						</Select>
					</Form.Item>
					<Form.Item label="Marriage Anniversary" name="marriageAnniversary">
						<DatePicker format="YYYY-MM-DD" />
					</Form.Item>
					<Form.Item label="Gender" name="gender">
						<Select placeholder="Select Gender">
							<Select.Option value="Male">Male</Select.Option>
							<Select.Option value="Female">Female</Select.Option>
							<Select.Option value="Other">Other</Select.Option>
						</Select>
					</Form.Item>
					<Form.Item label="PAN" name="pan">
						<Input placeholder="PAN" />
					</Form.Item>
					<Form.Item label="Aadhar" name="aadhar">
						<Input placeholder="Aadhar Number" />
					</Form.Item>
					<Form.Item>
						<Button type="primary" htmlType="submit" loading={loader} block>
							Update
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</>
	);
};

export default ProfileEditPopup;

